import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import AttachmentsTableRow from './AttachmentsTableRow';

const styles = theme => ({
  root: {
    minHeight: 300,
    overflow: 'hidden',
  },
  typography: {
    marginLeft: 24,
    marginBottom: 16,
  },
  tableHead: {
    backgroundColor: theme.palette.grey[100],
  },
  tableRow: {
    height: 35,
  },
  tableCell: {
    paddingTop: 5,
    paddingBottom: 5,
    borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  tableCellDate: {
    width: 120,
  },
  tableCellID: {
    width: 180,
  },
  tableCellActions: {
    width: 16,
    paddingRight: 29,
    '&:last-child': {
      paddingRight: 29,
    },
  },
});

const AttachmentsTable = ({
  attachments,
  business,
  onAttachmentView,
  classes,
}) => (
  <div className={classes.root}>
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.tableRow}>
          <TableCell className={classNames(classes.tableCell, classes.tableCellDate)}>
            Date
          </TableCell>
          <TableCell className={classes.tableCell}>Status</TableCell>
          <TableCell className={classNames(classes.tableCell, classes.tableCellID)}>
            Attachment #
          </TableCell>
          <TableCell className={classes.tableCell}>File</TableCell>
          <TableCell className={classNames(classes.tableCell, classes.tableCellActions)} />
        </TableRow>
      </TableHead>
      <TableBody>
        {attachments.map(item => (
          <AttachmentsTableRow
            key={item.ID}
            {...item}
            business={business}
            onAttachmentView={onAttachmentView}
          />
        ))}
      </TableBody>
    </Table>
  </div>
);

AttachmentsTable.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  onAttachmentView: PropTypes.func.isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
    tableHead: PropTypes.string.isRequired,
    tableRow: PropTypes.string.isRequired,
    tableCell: PropTypes.string.isRequired,
    tableCellDate: PropTypes.string.isRequired,
    tableCellActions: PropTypes.string.isRequired,
  }).isRequired,
};

AttachmentsTable.defaultProps = {
  business: {},
};

export default withStyles(styles)(AttachmentsTable);



// WEBPACK FOOTER //
// ./src/components/reports/AttachmentsDialog/AttachmentsTable.js